export default __webpack_public_path__ + "static/media/plus.01b61d49.svg";